import { CheckIcon } from '@chakra-ui/icons';
import {
    FormControl, FormLabel, FormErrorMessage, Input, InputGroup, InputRightElement
} from '@chakra-ui/react';
import {
    FormikErrors, FormikHandlers
} from 'formik';
import React, { HTMLInputTypeAttribute } from 'react';

import {
    isDefined, isEmpty
} from '@utils';

type FormInputProps = {
    'data-testid': string
    errors: FormikErrors<any>
    isRequired?: boolean
    labelText: string
    name: string
    onChangeHandler: FormikHandlers['handleChange']
    type: HTMLInputTypeAttribute
    value: string
    isReadOnly?: boolean
};

export const FormInput = ({
    'data-testid': dataTestId,
    errors,
    isRequired = false,
    labelText,
    name,
    onChangeHandler,
    type,
    value,
    isReadOnly = false
}: FormInputProps) => {
    const isInvalid = isDefined(errors[name]);
    const showCheckIcon = !isInvalid && !isEmpty(value) && !isReadOnly;

    return (
        <FormControl
            isRequired={isRequired}
            isInvalid={isDefined(errors[name])}
        >
            <FormLabel
                id={`label-${name}`}
                htmlFor={name}
            >
                {labelText}
            </FormLabel>
            <InputGroup>
                <Input
                    data-testid={dataTestId}
                    data-lpignore={'true'}
                    focusBorderColor={'primary.500'}
                    id={name}
                    onChange={onChangeHandler}
                    type={type}
                    value={value}
                    isReadOnly={isReadOnly}
                />
                {showCheckIcon && (
                    <InputRightElement>
                        <CheckIcon color={'green.500'} />
                    </InputRightElement>
                )}
            </InputGroup>

            <FormErrorMessage data-testid={`error-${dataTestId}`}>
                {errors[name] && errors[name]}
            </FormErrorMessage>
        </FormControl>
    );
};
